<template>
  <div class="yk-container">
    <el-row class="tcf-row" style="height: 100%;">
      <el-col class="card" style="height: 100%;">
        <div class="card-body" style="height: 100%;padding: 0;">
          <div class="card-content" style="height: 100%">
            <iframe class="ifm" src="https://book.yunzhan365.com/bookcase/fgqb/index.html"></iframe>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'

export default {
  name: 'yk',
  computed: {
    user: getUser
  }
}
</script>

<style lang="scss" scoped>
.yk-container {
  height: 100%;
  .ifm{
    width: 100%;
    height: 100%;
    border: 0;
  }
}
</style>
